import Axios from './Axios';

const API_URL = '/specialty/';

export const Speciality = {
  getList: () => Axios.get(API_URL + 'getList'),
  getOne: (params) => Axios.get(API_URL + 'get', params),
  add: (values) => Axios.post(API_URL + 'add-specialty', values),
  update: (values) => Axios.post(API_URL + 'update', values),
  delete: (params) => Axios.delete(API_URL + params)
};
